import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons'
import { colorAlert } from '@calendly/ui/theme'

import { LockTimezone as LockTimezoneField } from 'components/event_type_edit'
import { useEventType } from 'features/event_type_provider'

import {
  PanelContentContainer,
  PanelContentHeader,
  PanelContentSubtitle,
  PanelContentTitle,
  PanelContentValueLocked
} from '../styles'
import { TimezoneWarning } from './timezone_warning'

const TimezoneDisplayLocked = () => (
  <PanelContentContainer section>
    <PanelContentHeader isLocked>
      <PanelContentTitle>
        {I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.timezone.title')}
      </PanelContentTitle>
      <PanelContentValueLocked>
        <LockTimezoneField isLocked v3Style />
      </PanelContentValueLocked>
    </PanelContentHeader>
    <PanelContentSubtitle>
      {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.timezone_display_description')}
    </PanelContentSubtitle>
  </PanelContentContainer>
)

const TimezoneDisplaySection = () => {
  const eventType = useEventType()
  const { values: { lockTimezoneStatus } } = useFormContext()

  const {
    owner_type: ownerType,
    location_configurations: locationConfigurations,
    isMETParent
  } = eventType

  const hasPhysicalLocation = locationConfigurations.filter((config) => config.kind === 'physical').length > 0
  const showTimezoneWarning = (lockTimezoneStatus !== 'locked' && hasPhysicalLocation)

  return (
    <PanelContentContainer section data-testid="timezone_display_section">
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.timezone.title')}
          {showTimezoneWarning && <AlertWarningTriangleIcon color={colorAlert} data-testid="outer_timezone_warning" spacingLeft="8" />}
        </PanelContentTitle>
        <PanelContentSubtitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.timezone_display_description')}
        </PanelContentSubtitle>
      </PanelContentHeader>
      {showTimezoneWarning && <TimezoneWarning />}
      <PanelContentContainer subsection>
        <LockTimezoneField v3Style ownerType={ownerType} isMETParent={isMETParent} />
      </PanelContentContainer>
    </PanelContentContainer>
  )
}

export const TimezoneDisplay = ({ isLocked }) => (
  !isLocked ? <TimezoneDisplaySection /> : <TimezoneDisplayLocked />
)
